import React, { useState } from "react";
import filterList from "../images/filter_list.svg";
import { LEAD_STATUSES } from "../constants/statusConstants";

const statusOptions = ["All", ...LEAD_STATUSES];

const StatusFilter = ({ currentStatus, setCurrentStatus }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative inline-block">
      {/* Trigger button */}
      <div
        className="flex items-center gap-2 px-3 py-2 border border-gray-200 cursor-pointer rounded-xl hover:bg-gray-50 text-slate-600"
        onClick={() => setIsOpen(!isOpen)}
      >
        <img src={filterList} alt="filters icon" className="w-4 h-4" />
        <span className="text-sm font-medium">{currentStatus || "Filters"}</span>
      </div>

      {/* Dropdown options */}
      {isOpen && (
        <div className="absolute mt-1 w-40 bg-white border border-gray-200 rounded shadow-lg z-50">
          {statusOptions.map((status) => (
            <div
              key={status}
              className={`px-4 py-2 cursor-pointer hover:bg-gray-100 ${
                currentStatus === status ? "font-semibold bg-gray-100" : ""
              }`}
              onClick={() => {
                setCurrentStatus(status);
                setIsOpen(false);
              }}
            >
              {status}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StatusFilter;